const DEFAULT_CANVAS_TEXT_COLOR = 'rgb(248, 250, 252)'

const classSlug = (className: string) =>
  className.toLowerCase().replace(/\s+/g, '-')

const colorCache = new Map<string, string>()

const resolveCanvasVariable = (variable: string, fallback: string): string => {
  if (typeof document === 'undefined') return fallback
  const cached = colorCache.get(variable)
  if (cached !== undefined) return cached
  const value = getComputedStyle(document.documentElement)
    .getPropertyValue(variable)
    .trim()
  const color = value || fallback
  colorCache.set(variable, color)
  return color
}

export const resolveCanvasClassColor = (className: string): string =>
  resolveCanvasVariable(
    `--color-class-${classSlug(className)}`,
    DEFAULT_CANVAS_TEXT_COLOR,
  )

export const resolveCanvasSubscriptionGoldColor = (): string =>
  resolveCanvasVariable('--color-subscription-gold', 'rgb(255, 215, 0)')
